<template>
  <u-deploy-panel>
    <template slot="title">
      {{ $t('title')}}
    </template>
    <template slot="content">
      <p>{{ $t('trial') }}</p>
      <p>{{ $t('licensed') }}</p>
      <u-deploy-selection
        :items="types"
        :selected="selected"
        @toggle="toggle"
      />
    </template>
    <template slot="actions">
      <v-spacer />
      <v-btn text @click="$emit('cancel')">{{ $t('wizard.cancel') }}</v-btn>
      <v-btn text @click="$emit('prev')">{{ $t('wizard.prev') }}</v-btn>
      <v-btn :disabled="!selected" color="primary" @click="$emit('next')">{{ $t('wizard.next') }}</v-btn>
    </template>
  </u-deploy-panel>
</template>

<script>
import DeployPanelComponent from '@/components/deploy/Panel.vue'
import DeploySelectionComponent from '@/components/deploy/Selection.vue'

export default {
  data () {
    return {
      selected: null,
      types: [
        {
          id: 'trial',
          available: true,
          name: this.$t('types.trial.name'),
          type: this.$t('types.trial.type'),
          image: `${require('../../assets/calendar-badge-outline.svg')}`,
          tooltip: this.$t('tooltip.trial')
        },
        {
          id: 'licensed',
          available: false,
          name: this.$t('types.licensed.name'),
          type: this.$t('types.licensed.type'),
          image: `${require('../../assets/license.svg')}`,
          tooltip: this.$t('tooltip.licensed')
        }
      ]
    }
  },
  methods: {
    toggle (item) {
      this.selected = this.selected === item ? null : item
    }
  },
  components: {
    'u-deploy-panel': DeployPanelComponent,
    'u-deploy-selection': DeploySelectionComponent
  }
}
</script>

<i18n>
{
  "en": {
    "title": "Pick your deployment type",
    "trial": "A Trial deployment lets you explore the platform and can later be upgraded to a Licensed deployment by entering a valid license key.",
    "licensed": "If you plan to perform a Licensed deployment but the option is grayed out, please contact Unryo Support for assistance.",
    "tooltip": {
      "licensed": "Properly licensed. Please contact Unryo support.",
      "trial": "Trial license that can be upgraded later."
    },
    "types": {
      "licensed": {
        "name": "Licensed",
        "type": "Licensed"
      },
      "trial": {
        "name": "Trial",
        "type": "Trial"
      }
    }
  }
}
</i18n>
